// src/components/Careers/LifeAndPeople/LifeAndPeople.js
import React from 'react';
// import EmployeeCard from './EmployeeCard';
import './LifeAndPeople.css';
import EmployeeCard from './EmploeeCard';

const employees = [
  {
    name: 'Richard Clough, Customer Success Manager',
    quote: 'Joining Sendbird isn’t just a career choice; it’s an opportunity to cultivate meaningful connections and drive exceptional customer experiences in the world of cutting-edge communication technology.',
    imageUrl: 'https://sendbird.imgix.net/cms/Richards-employee-quote.png?auto=format,compress&crop=faces&w=672'
  },
  {
    name: 'Yeji Yoon, Chief of Staff',
    quote: 'I wanted to join a company with a strong culture of growth. At Sendbird, I get to be a part of a team and be my best self, a place where the team’s growth as well as my own is aligned with the company’s success.',
    imageUrl: 'https://sendbird.imgix.net/cms/yeji_2022-12-13-214859_sobc.png?auto=format,compress&crop=faces&w=672'
  },
  {
    name: 'Shailesh Nalawad, Head of PM',
    quote: 'I feel proud to work on a product that is used by hundreds of millions of people every day, all over the world.',
    imageUrl: 'https://sendbird.imgix.net/cms/shailesh_2022-12-13-214849_hyxl.png?auto=format,compress&crop=faces&w=672'
  }
];

function LifeAndPeople() {
  return (
    <section className="life-people-section">
      <div className="life-people-container">
        <h2 className="section-title">Life & People at Sendbird</h2>
        <div className="employee-cards-container">
          {/* Now the .map() function has the 'employees' array to iterate over */}
          {employees.map((employee, index) => (
            <EmployeeCard key={index} {...employee} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default LifeAndPeople;
